import React from 'react';
import ProfilerNavbar from '../profilerEditingPage/profilerNavBar';
import OtherJobCard from './otherJobCards';
import JobDetailContent from './jobDetailContent'; // --- Step 1: Import the new component ---
import { FiSearch } from 'react-icons/fi';
import { profilerJobDetailData } from '../../../data/mockProfilerJobDetailData';

const ProfilerJobDetailPage = () => {
  const { mainJob, otherJobs } = profilerJobDetailData;

  return (
    <div className="min-h-screen main-background">
      <ProfilerNavbar />
      <main className="mx-auto pt-20 px-8 pb-8">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">

          {/* --- Left Column: Main Job Details --- */}
          {/* Step 2: Use the new component and pass the job data to it */}

          <div className="lg:col-span-2">
            <div className="flex items-center gap-4 rounded-lg mb-4 w-fit">
              <button className="bg-white text-xs mph-primary font-semibold px-4 py-2 rounded-full shadow-sm">
                About job
              </button>
            </div>
            <JobDetailContent job={mainJob} />
          </div>

          {/* --- Right Column: Other Jobs --- */}
          <aside className="lg:col-span-1 p-6 h-full">
            <div className="flex items-center gap-3 w-full mb-4">
              <div>
                <button className="bg-white text-xs mph-primary font-semibold px-3 py-1.5 shadow-md rounded-xl">Other jobs</button>
              </div>
              <div className="relative flex-1">
                <input
                  type="text"
                  placeholder="Search for jobs..."
                  className="w-full bg-white shadow-md text-xs rounded-full py-2.5 pl-4 pr-10"
                />
                <FiSearch className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400" />
              </div>
              <div>
                <a href="#" className="text-xs font-semibold mph-primary whitespace-nowrap">View all</a>
              </div>
            </div>
            <div
              className="space-y-4 overflow-y-auto custom-scrollbar p-4 rounded-xl bg-white"
              style={{
                maxHeight: 'calc(100vh - 180px)',
                minHeight: '200px',
                height: 'auto'
              }}
            >
              {otherJobs.map((job) => (
                <OtherJobCard key={job.id} job={job} />
              ))}
            </div>
          </aside>

        </div>
      </main>
    </div>
  );
};

export default ProfilerJobDetailPage;